module.exports = __webpack_public_path__ + "static/img/39861.17b432c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/39861.jpg
// module id = EVsG
// module chunks = 1